import { initEmblaSlider } from './embla';

type EmblaInstance = {
  reInit?: () => void;
  destroy?: () => void;
};

type API = {
  setActive: (value: string) => void;
  getActive: () => string | null;
};

type Options = {
  rootSelector?: string; // container that wraps radios + tracks (default '.js-pricing')
  radioSelector?: string; // radios (default 'input[name="frequency"]')
  trackSelector?: string; // carousel/table roots (default '.js-embla-pricing[data-table]')
  activeClass?: string; // class for active track (default 'is-active')
};

export function initPricingWithEmbla({
  rootSelector = '.js-price',
  radioSelector = 'input[name="frequency"]',
  trackSelector = '.price-card[data-table]',
  activeClass = 'is-active',
}: Options = {}): API {
  const root = document.querySelector<HTMLElement>(rootSelector);
  if (!root) return noop();

  const radios = Array.from(
    root.querySelectorAll<HTMLInputElement>(radioSelector)
  );
  const tracks = Array.from(root.querySelectorAll<HTMLElement>(trackSelector));
  console.log(tracks);

  if (!radios.length || !tracks.length) return noop();

  const trackByValue = new Map<string, HTMLElement>();

  tracks.forEach((el) => {
    const val = el.dataset.table || '';

    if (val) trackByValue.set(val, el);
  });

  let activeValue: string | null = null;

  const setRadiosA11y = (value: string) => {
    radios.forEach((r) => {
      const is = r.value === value;
      r.checked = is;
      r.setAttribute('aria-selected', String(is));
    });
  };

  const setActive = (value: string) => {
    if (!value || value === activeValue) return;

    console.log(value, activeValue);

    tracks.forEach((el) => {
      const is = el.dataset.table === value;
      el.classList.toggle(activeClass, is);
      el.toggleAttribute('hidden', !is);
    });

    setRadiosA11y(value);

    activeValue = value;
  };

  const getActive = () => activeValue;

  const onChange = (e: Event) => {
    const t = e.target as HTMLInputElement | null;
    if (!t || t.name !== 'frequency' || t.type !== 'radio' || !t.checked)
      return;
    if (!trackByValue.has(t.value)) return; // ignore orphan values
    setActive(t.value);
  };

  root.addEventListener('change', onChange);

  const initial =
    radios.find((r) => r.checked && trackByValue.has(r.value))?.value ??
    radios.find((r) => trackByValue.has(r.value))?.value ??
    null;

  if (initial) setActive(initial);

  return { setActive, getActive };
}

function noop(): API {
  return {
    setActive: () => {},
    getActive: () => null,
  };
}
